export default __webpack_public_path__ + "static/media/outlook-2019.bfb4d1b5.svg";